import React, { Component } from "react";
import { Row, Col } from "antd";
import Category from "../../components/CategoriesCard";
import CatalogCustomization from "../../components/catalogCustomization";
import CatalogCard from "../../components/catalogCard";
import { Store } from "../../store";
import { connect } from "react-redux";
import { CatalogAction, UserAction } from "../../store/actions";
import General_Info from "../../components/generalInfo";

class CatalogNew extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isClose: false,
      isOpenModal: false,
      filters: {
        order: "asc",
        page: 1,
        per_page: 12,
        column: "name",
        category_id: 1,
        status: "active",
      },
      categoryName: "",

      shipingprice: {
        am_charges: "0.0",
        pm_charges: "0.0",
      },
      price: "",
    };
  }

  abc = (key) => {
    this.setState({
      filters: {
        ...this.state.filters,
        category_id: key.id,
      },
      categoryName: key.name,
    });
  };

  componentDidMount() {
    const userId = this.props.user?.[2].rmx_company_user?.id
    const {
      getProducts,
      getCategories,
      getShippingCost,
      basemixdata,
      getbasemixes,
      getadditives,
      getbasemixesCategories,
      getUserDetails
    } = this.props;
    getProducts(this.state.filters, true);
    getCategories();
    getShippingCost();
    basemixdata();
    getbasemixes();
    getadditives();
    getbasemixesCategories();
    getUserDetails(userId)

  }

  componentDidUpdate(preProps, preState) {
    const { getProducts,categories } = this.props;

    if (preProps.metaData !== this.props.metaData) {
      this.setState({
        filters: {
          ...this.state.filters,
          page: this.props?.metaData?.current_page,
          total_records: this.props?.metaData?.total_records,
          current_records: this.props?.metaData?.current_records,
          total_pages: this.props?.metaData?.total_pages,
        },
      });
    }

    if (
      preState.filters.category_id !== this.state.filters.category_id ||
      preState.filters.column !== this.state.filters.column ||
      preState.filters.per_page !== this.state.filters.per_page ||
      preState.filters.page !== this.state.filters.page
    ) {
      getProducts(this.state.filters, true);
    }
    if (preProps.shipingprice !== this.props.shipingprice) {
      this.setState({
        shipingprice: {
          am_charges: this.props?.shipingprice?.am_charges,
          pm_charges: this.props?.shipingprice?.pm_charges,
        },
      });
    }
    if(preProps.categories?.length!==categories?.length){
      getProducts(
        { ...this.state.filters, category_id: categories?.[0]?.id },
        null
      )
      this.setState({
        categoryName:this.props.categories[0]?.name
      })
    }
  }

  currentPage = (e) => {
    this.setState({
      filters: {
        ...this.state.filters,
        page: this.state.filters?.page + 1,
      },
    });
  };
  previousPage = (e) => {
    this.setState({
      filters: {
        ...this.state.filters,
        page: this.state.filters?.page - 1,
      },
    });
  };

  onChangeShowingFilter = (value) => {
    this.setState({
      filters: {
        ...this.state.filters,
        per_page: value,
      },
    });
  };

  onUpdateShippingCost = (e, type) => {
    this.setState({
      shipingprice: {
        ...this.state.shipingprice,
        [type]: e,
      },
    });
  };

  onUpdatePrice = (price) => {
    this.setState({
      price: price,
    });
  };

  onChangeFilter = (value) => {
    this.setState({
      filters: {
        ...this.state.filters,
        column: value,
      },
    });
  };

  render() {
    if (this?.props?.location?.state?.fromCustom) {
      return <General_Info />;
    }
    console.log('userDetail==>', this.props.user?.[1].rmx_company?.allowed_for_catalog_customization)
    return (
      <Row style={{ marginTop: '-10px' }} >
        <Col xl={6} lg={6} xs={24} sm={24} md={24}>
          <Category
            abc={this.abc}
            categorey={this.props.categories}
            categoryName={this.state.categoryName}
            {...this.props}
          />
          {/* {this.props.user?.[1].rmx_company?.allowed_for_catalog_customization &&
            <CatalogCustomization
              categories={this.props.categories}
              getTemplateRequest={this.props.getTemplate}
              uploadFile={this.props.postFile}
            />
          } */}
        </Col>
        <Col xl={18} lg={18} xs={24} sm={24} md={24}>
          <CatalogCard
            {...this.props}
            categoryName={this.state.categoryName}
            onChangeFilter={this.onChangeFilter}
            onChangeShowingFilter={this.onChangeShowingFilter}
            metaData={this.props.metaData}
            currentPage={this.currentPage}
            previousPage={this.previousPage}
            updateProductPrice={this.props.updateProduct}
            onUpdateProductPrice={this.onUpdatePrice}
            value={this.state.price}
            onOpenModal={(e) => this.setState({ price: e })}
            fromNewCatalog={true}
            NewCatalogInput={true}
            postProduct={this.props.postProduct}
            isProductLoading={this.props.isAddingProduct}
            dividerShow={true}
          />
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = (store) => {
  return {
    products: store.CatalogReducer.products,
    metaData: store.CatalogReducer.metaData,
    categories: store.CatalogReducer.categories,
    shipingprice: store.CatalogReducer.shipingprice,
    basemixData: store.CatalogReducer.basemixData,
    isLoadingCategory: store.CatalogReducer.isLoadingCategorey,
    isLoading: store.CatalogReducer.isLodading,
    isAddingProduct: store.CatalogReducer.isAddingProduct,
    user: store.AuthReducer.user,

  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getCategories: (params) => dispatch(CatalogAction.getCategoriesReq(params)),
    getProducts: (params, isTrue) =>
      dispatch(CatalogAction.getProductReq(params, true)),
    updateShippingCost: (value, id) =>
      dispatch(CatalogAction.updateShipingCostReq(value, id)),
    getShippingCost: () => dispatch(CatalogAction.getShipingCostReq()),
    updateProduct: (value, id, active) =>
      dispatch(CatalogAction.updateProductReq(value, id, active)),
    postProduct: (payload, cb) => dispatch(CatalogAction.postProductReq(payload, cb)),
    basemixdata: (params) =>
      dispatch(CatalogAction.getBasemixCategoriesReq(params)),
    getbasemixes: (params) => dispatch(CatalogAction.getBasemixesReq(params)),
    getadditives: (params) => dispatch(CatalogAction.getAdditivesReq(params)),
    getbasemixesCategories: (params) =>
      dispatch(CatalogAction.getBasemixesCategoriesReq(params)),
    getTemplate: (params) => dispatch(CatalogAction.getTemplateReq(params)),
    postFile: (payload) => dispatch(CatalogAction.postFileReq(payload)),
    getUserDetails: (id) => dispatch(UserAction.getUserDetailReq(id))

  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CatalogNew);
